(function(algolia) {
  'use strict';

  algolia.translations = {
    search: 'Current search',
    noCollectionFound: 'No collection found',
    allProducts: 'See all products',
    matching: 'matching',
    sortBy: 'Sort by',
    relevance: 'Relevance',
    outOf: 'of',
    resultsFound: 'results',
    oneResultFound: '1 result found',
    noResultFound: 'We can\'t find the part you\'re looking for.',
    addToCart: 'Add to cart',
    searchForProduct: 'Search for products',
    selectedFilter: 'Selected filters',
    clearAll: 'Clear all',
    noPageFound: 'No page found',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    notInStock: 'Not in Stock'
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'No result for query ' + render(text) + '';
    },
    in: function(text, render) {
    //   return 'in ' + render(text) + 's';
      return '';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      console.log('html_tags', html_tags);
      
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' updating your search. Our qualified techs can help you Find the Perfect Part for your application by calling 909-599-5955.' +
        render(html_tags[3]) +
        ''
      );
    },
    outOf: function(text, render) {
      return 'Showing ' + render(text) + ' of';
    },

    by: function(text, render) {
      return 'by ' + render(text) + '';
    },
  };
})(window.algoliaShopify);
